<template>
  <a :href="this.url" :class="{'router-link': true, 'disabled':disabled}">
    <slot>{{ text }}</slot>
  </a>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'page',
    },
    empty: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    applink()
    {
      if (this.id !== undefined && this.type !== null) {
        return this.$store.getters['applinks/getLink'](this.type, this.id);
      }
    },
    url() {
      if (this.applink) return this.applink.url;
    },
    text() {
      if (this.applink && !this.empty) return this.applink.text;
    },
  },
};
</script>
